export const SESSION_STORAGE_PERFORMANCE_DATE_RANGE_KEY = "localPerformanceDateRange";

export function getStoredPerformanceDateRangeFromSession(): Record<
  string,
  { startDate: string; endDate: string }
> {
  try {
    return JSON.parse(
      sessionStorage.getItem(SESSION_STORAGE_PERFORMANCE_DATE_RANGE_KEY) || "{}"
    );
  } catch {
    return {};
  }
}
